// extracted by mini-css-extract-plugin
export default {"status_icon":"AmMJZwX2WFYOGS+Ei17heg==","dnd":"_8m+lOOYv8EExXnUWDhnvoQ==","online":"mHXzjwNc5siSYObA+kgB+A==","away":"rvvrumS4PhgwuTdx9nYVLw==","offline":"BhjJMDtV3pHv5DRmxMWWWA=="};